import { HttpService } from '@/shared/services'
import List from '@/shared/dtos/List'
import GetEmployessInputDto from './interfaces/GetEmployeeInputDto'
import EmployeeList from '../models/EmployeeList'
import { EmployeeDetail } from '../models/EmployeeDetail'
import EmployeeSupervisor from '../models/EmployeeSupervisort'
import { SubordinatedEmployeeDto } from '../models/SubordinatedEmployee'

const http = new HttpService()

export const getEmployees = async (dto: GetEmployessInputDto) => {
  const { companyId, payrollId, requireUserData } = dto

  let url = `employee/company/${companyId}`

  if (payrollId !== undefined) {
    url += `?payrollId=${payrollId}`
  }

  if (requireUserData !== undefined) {
    url += `?requireUserData=${requireUserData}`
  }

  const response = await http.get<EmployeeList>(url)

  return response?.data ?? []
}

export const getEmployeeById = async (employeeId: string) => {
  const response = await http.get<EmployeeDetail>('employee/' + employeeId)
  return response?.data ?? null
}

export const geEmployeesByPayrollid = async (
  getEmployeesDto: GetEmployessInputDto
) => {
  const response = await http.get<List<EmployeeSupervisor[]>>(
    `employee/payroll/${getEmployeesDto.payrollId}?limit=${getEmployeesDto.pagination?.limit}&offset=${getEmployeesDto.pagination?.offset}&search=${getEmployeesDto.pagination?.search}`
  )

  return response?.data ?? []
}

export const getEmplopeesByPayrollConfigId = async (
  payrollConfigId: string
) => {
  const response = await http.get<EmployeeSupervisor[]>(
    `employee/payrollConfig/${payrollConfigId}`
  )
  return response.data ?? []
}

export const getEmployeesByApproverId = async (approverId: string) => {
  const response = await http.get<SubordinatedEmployeeDto[]>(
    `employee/approver/${approverId}`
  )
  return response.data ?? []
}
